<template>
  <div>
    <wc-data-box
      :title='storePath.title'
      :titleIcon='storePath.icon'
      :titleIconColor='storePath.iconColor'
      showEdit
      @edit='openEdit'
      :loading='isLoading'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Division</td>
            <td :class='dataValue'>
              <wc-division-nai :division_obj='item.division_obj'/>
            </td>
          </tr>
          <tr>
            <td :class='label'>VIN</td>
            <td :class='dataValue'>{{ item.vin }}</td>
          </tr>
          <tr>
            <td :class='label'>License Plate</td>
            <td :class='dataValue'>{{ item.license_plate }}</td>
          </tr>
          <tr>
            <td :class='label'>Notes:</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text v-html='item.notes' class='pt-0'>
      </v-card-text>
    </wc-data-box>
<!-- edit dialog box below  -->
     <wc-dialog
      :showDialog='showDialog'
      title='Edit Details'
      :icon='storePath.icon'
      :iconColor='storePath.iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
      :disableButtons='!isFormValid'
    >
      <v-form v-model="isFormValid" ref='form'>
<!-- do we allow edit for the division to happen here? or is this set at creation? -->
        <v-text-field
          label='Vehicle Identification Number'
          v-model='itemCopy.vin'
        ></v-text-field>
        <v-text-field
          label='Licence Plate Number'
          v-model='itemCopy.license_plate'
        ></v-text-field>
        <span>Notes</span>
        <v-textarea outlined auto-grow v-model='itemCopy.notes'></v-textarea>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'vehicle-details',
  props: {
    item: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isFormValid: false,
    label: 'grey--text',
    dataValue: 'text-right',
    showDialog: false,
    icon: null,
    iconColor: null,
    itemCopy: {},
  }),
  computed:{
    storePath () { return this.$store.state.icons.dataBox.details }
  },
  methods: {
    openEdit () {
      this.itemCopy = _.cloneDeep(this.item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.isLoading = true
      console.log(this.itemCopy)
      this.$emit('update', this.itemCopy)
      this.showDialog = false
      this.isLoading = false
    }
  }
}
</script>